import { render, staticRenderFns } from "./Majors.vue?vue&type=template&id=8a48371c"
import script from "./Majors.vue?vue&type=script&lang=js"
export * from "./Majors.vue?vue&type=script&lang=js"
import style0 from "./Majors.vue?vue&type=style&index=0&id=8a48371c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports